import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { OmniGeralRestService } from './../../omni-rest/omni-geral/omni-geral-rest.service';

@Injectable()
export class TipoTransporteService {

  constructor(
    private _restService: OmniGeralRestService
  ) { }

  getTipoTransporte():Observable<any> {
    return this._restService.get('tipos-transportes');
  }
}
